import { Chip, ChipBackgroundColor, ChipSize } from "@amzn/stencil-react-components/chip";
import { PopoverController, PopoverPosition } from "@amzn/stencil-react-components/dist/submodules/popover";
import { Text } from "@amzn/stencil-react-components/text";
import { IconSize } from "@amzn/stencil-react-icons";
import { Link } from "@amzn/uxm-stencil-react-components/lib/src/stencil/link";
import { getString } from "common/uistringlabels/uiStringUtils";
import React, { FC, useRef, useState } from "react";

import InfoIconButton from "../InfoIconButton";

export interface DataClassificationChipProps {
  /**
   * text to use in the chip
   */
  label?: string;
}

/** Reusable Data Classification chip component. */
export const DataClassificationChip: FC<DataClassificationChipProps> = ({ label }) => {
  const [isOpen, setIsOpen] = useState(false);
  const target = useRef<HTMLButtonElement>(null);

  const close = () => setIsOpen(false);
  const toggle = () => setIsOpen(!isOpen);

  if (!label) {
    return null;
  }

  return (
    <Chip
      key="dataClassification"
      data-testid="dataClassification"
      size={ChipSize.ExtraSmall}
      backgroundColor={ChipBackgroundColor.Blue}
    >
      {label}
      <InfoIconButton
        ref={target}
        iconSize={IconSize.ExtraSmall}
        data-testid="dataClassificationIcon"
        onClick={(e) => {
          toggle();
          e.preventDefault();
          e.stopPropagation();
        }}
      />
      <PopoverController target={target} isOpen={isOpen} close={close} position={PopoverPosition.TopCenter}>
        <div style={{ padding: "8px 12px", maxWidth: "300px" }}>
          <Text fontSize="T100">
            {getString("aiForMe.tags.dataClassificationPopover.prefix")}{" "}
            <Link
              href={getString("aiForMe.tags.dataClassificationPopover.linkUrl")}
              target="_blank"
              rel="noopener noreferrer"
              touchpoint="dataclassification-wiki"
            >
              {getString("aiForMe.tags.dataClassificationPopover.linkText")}
            </Link>{" "}
            {getString("aiForMe.tags.dataClassificationPopover.suffix")}
          </Text>
        </div>
      </PopoverController>
    </Chip>
  );
};

export default DataClassificationChip;
